// Delivery dates arrive as calendar dates ('2026-10-24', or '2026-10-24 00:00:00' from an order), so build them in
// local time: new Date('2026-10-24') is UTC midnight, which is still the day before across the Americas
export const parseDeliveryDate = (value) => {
    const [year, month, day] = String(value).slice(0, 10).split('-').map(Number)

    return new Date(year, month - 1, day)
}

// A locale the browser can use, or undefined for its own (Intl throws on anything else)
const usableLocale = (locale) => {
    try {
        return Intl.getCanonicalLocales(locale)[0]
    } catch (error) {
        return undefined
    }
}

// e.g. "Saturday 24 October", with the year only when it isn't this year
export const formatDeliveryDate = (value, locale) => {
    const date = parseDeliveryDate(value)
    const options = { weekday: 'long', day: 'numeric', month: 'long' }

    if (date.getFullYear() !== new Date().getFullYear()) {
        options.year = 'numeric'
    }

    return date.toLocaleDateString(usableLocale(locale), options)
}

// One part of the date for the calendar tile: the short month ("Oct") or the day ("24")
export const deliveryDatePart = (value, locale, part) => {
    const parts = new Intl.DateTimeFormat(usableLocale(locale), { day: 'numeric', month: 'short' }).formatToParts(parseDeliveryDate(value))

    return (parts.find((p) => p.type === part)?.value ?? '').replace(/\.$/, '')
}
